import React, { Component, useEffect, useState } from 'react';
import welcome from './components/Utilities/welcome';
import {
  BrowserRouter as Router,
  Routes,
  Switch,
  Route,
  useLocation,
  
} from 'react-router-dom';
// import 'antd/dist/antd.css';
import './App.css';

import { PrivateRoute } from './components/PrivateRouter/PrivateRoute';
import Dashboard from './components/pages/Dashboard';
import StoreDashboardRetail from './components/pages/storeDashboardRetail';
import WareHouseDashBoard from './components/pages/WareHouseDashBoard';
import StoreDashboardWareHouse from './components/pages/storeDashboardWareHouse';
import Incidents from './components/pages/Incidents';
import Handovers from './components/pages/Handovers';
import FedIdExtract from './components/pages/FedIdExtract';
import Evacuations from './components/pages/Evacuations';
import Nonconformities from './components/pages/Nonconformities';
import AddUser from './components/pages/AddUser';
import EditChecklist from './components/pages/EditChecklist';
import EditIncidentEmailConfig from './components/pages/EditIncidentEmailConfig';
import ProjectTracker from './components/pages/ProjectTracker';
import Audits from './components/pages/Audits';
import GatePass from './components/pages/GatePass';
import Project from './components/pages/Project';
import SafetyRegister from './components/pages/SafetyRegister/safetyRegister';
import PurchaseOrder from './components/pages/PurchaseOrder';
import ManageUserStores from './components/pages/ManageUserStores';
import PdfExport from './components/pages/PDFExport/PdfExport';
import PdfExportStore from './components/pages/PDFExport/PdfExportStore';
import PdfExportWarehouse from './components/pages/PDFExport/PdfExportWarehouse';
import PdfStoreWarehouse from './components/pages/PDFExport/PdfStoreWarehouse';
import PdfExportCityLeader from './components/pages/PDFExport/PdfExportCityLeader';
import Training from './components/pages/Training/Training';

import FedIDUrl from './components/pages/FedIDUrl';

import Cityleader from './components/pages/CityleaderDashboard';
import PageNotAllowed from './components/pages/PageNotAllowed';
import ViewImages from './components/pages/ViewImages';

import Login from "./components/Utilities/Login";
import Stores from "./components/pages/Store/StoresList";
import WareHouses from './components/pages/WareHouse/WareHouse';
import AddStore from "./components/pages/Store/AddStore";
import EditStore from "./components/pages/Store/EditStore";
import StoreView from "./components/pages/Store/StoreView";
import AssetCategoryList from "./components/pages/AssetCategory/AssetCategoryList";
import Vendors from "./components/pages/Vendor/VendorsList";
import VendorAdd from "./components/pages/Vendor/VendorAdd";
import VendorContract from "./components/pages/Vendor/VendorContract";
import VendorContractMapping from "./components/pages/Vendor/VendorContractMapping";
import Assets from "./components/pages/Assets/AssetsList";
import AddAsset from "./components/pages/Assets/AddAsset";
import PMPList from "./components/pages/PMP/PMPList";
import PMPSchedule from "./components/pages/PMP/PMPSchedule";
import PMPReschedule from "./components/pages/PMP/PMPReschedule";
import PMPScheduleCancel from "./components/pages/PMP/PMPScheduleCancel";

import PMPVendorList from "./components/pages/PMP/PMPVendorList";
import PMPVendorReschedule from "./components/pages/PMP/PMPVendorReshedule";
import PMPVendorAccept from "./components/pages/PMP/PMPVendorAccept";

import PaymentInvoiceCreation from "./components/pages/PaymentProcess/PaymentInvoiceCreation"
import PaymentInvoiceProcessSOM from "./components/pages/PaymentProcess/PaymentInvoiceProcessSOM"
import PaymentInvoiceProcessFinance from "./components/pages/PaymentProcess/PaymentInvoiceProcessFinance"
import PaymentInvoiceProcessSL from "./components/pages/PaymentProcess/PaymentInvoiceProcessSL"
import PaymentProcessApproveReject from "./components/pages/PaymentProcess/PaymentProcessApproveReject"
import PaymentProcessSOM from "./components/pages/PaymentProcess/PaymentProcessSOM"
import PaymentProcessSL from "./components/pages/PaymentProcess/PaymentProcessSL"
import PaymentRequestStore from "./components/pages/PaymentProcess/PaymentRequestStore"
import PaymentRequestApproveReject from "./components/pages/PaymentProcess/PaymentRequestApproveReject"

import BudgetCategoryMaster from "./components/pages/BudgetPlanner/BudgetCategoryMaster"
import BudgetPlannerSM from './components/pages/BudgetPlanner/BudgetPlannerSM'
import BudgetPlannerSOM from './components/pages/BudgetPlanner/BudgetPlannerSOM'
import BudgetPlannerApprovalZOMC from './components/pages/BudgetPlanner/BudgetPlannerApprovalZOMC'
import BudgetPlannerApprovalProcessZOMC from './components/pages/BudgetPlanner/BudgetPlannerApprovalProcessZOMC'
import BudgetPlannerApprovalFinance from './components/pages/BudgetPlanner/BudgetPlannerApprovalFinance'
import BudgetPlannerApprovalProcessFinance from './components/pages/BudgetPlanner/BudgetPlannerApprovalProcessFinance'

import AddDecathlonUser from './components/pages/Admin/AddDecathlonUser';
import ChangeUsersStore from './components/pages/Admin/ChangeUsersStore';
import RemoveUser from './components/pages/Admin/RemoveUser';
import WarehouseLeader from "./components/pages/WarehouseLeader";
import WorkOrder from './components/pages/WorkOrder/WorkOrder';
import WOReSchedule from './components/pages/WorkOrder/WOReSchedule';
import WareHouseView from './components/pages/WareHouse/WareHouseView';
import AddWareHouse from './components/pages/WareHouse/AddWareHouse';
import WorkOrderVendor from './components/pages/WorkOrder/WorkOrderVendor';
import QuotationStore from './components/pages/Quotation/QuotationStore';
import AddQuotation from './components/pages/Quotation/AddQuotation';
import EditQuotation from './components/pages/Quotation/EditQuotation';
import QuotationVendor from './components/pages/Quotation/QuotationVendor';
import ViewQuotation from './components/pages/Quotation/ViewQuotation';
import WorkOrderStore from './components/pages/WorkOrder/WorkOrderStore';
import EditWareHouse from './components/pages/WareHouse/EditWareHouse';
import VendorEdit from './components/pages/Vendor/VendorEdit';
import MaintenenceStoreDashBoard from './components/pages/StoreDashboard/MaintenenceStoreDashBoard';
import MaintenenceWareHouseDashBoard from './components/pages/WareHouseDashboard/MaintenenceWareHouseDashBoard';
import WasteManagementDashboard from './components/pages/WasteManagementDashboard'
import DeliveryEfficiency from './components/pages/DeliveryEfficiency/DeliveryEfficiency';
import SessionTimeout from './SessionTimeout';
import { setLogOut } from './components/pages/Store/actions/storeService';
import { useDispatch, useSelector } from 'react-redux';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Cookie from 'js-cookie';
import { ApiGateWay } from './components/ApiGateWay/ApiGateWay';
import { Config } from './components/config/config';
import { SecureRoute } from './components/PrivateRouter/SecureRoute';
import LZString from 'lz-string';
import TpvAdd from './components/pages/TPV/TpvAdd';
import TpvList from './components/pages/TPV/TpvList';
import PreviewTpvReport from './components/pages/TPV/previewTpvReport'
import Auditor from './components/pages/Auditor/AuditorList';
import AuditorAdd from './components/pages/Auditor/AuditorAdd';
import AuditorEdit from './components/pages/Auditor/AuditorEdit';
import AuditorContract from './components/pages/Auditor/AuditorContract';
import AuditorContractMapping from './components/pages/Auditor/AuditorContractMapping';
import MaintenanceDashboard from './components/pages/MaintenanceDashboard/MaintenanceDashboard';
import MaintenanceDashboardReport from './components/pages/MaintenanceDashboard/MaintenanceDashboardReport';
import Welcome from './components/Utilities/welcome';
import ContentModal from './components/helpers/shared/ContentModal';
import { notification } from 'antd';


function NoMatch() {
  const style = {
    display: 'block',
    textAlign: 'center',
    background: 'white',
  };
  const welHeader = {
    fontWeight: 'bold',

    color: ' #3c8dbc',
    fontFamily: 'Roboto Condensed',
    fontStyle: 'italic',
  };
  let location = useLocation();

  return (
    <div className='align-center' style={style}>
      <h3 style={welHeader}>
        The requested URL <code>{location.pathname}</code> was not found on this
        server.
      </h3>
    </div>
  );
}
const App =(props)=>  {
  const isLoginData = useSelector(state=> state.store.isLogin)
  const [isLogin, setIsLogin] = useState(isLoginData);
  const config = JSON.parse(Config);
  const apiInterface = config['api1'];
  // const [isAuthenticated, setAuth] = useState(false);
  const dispatch = useDispatch();
  const { notificationErrorList, showModal } = useSelector((state) => ({
    notificationErrorList: state?.notifications?.notificationErrorList,
    showModal: state?.notifications?.showModal,
  }));
    const handleClick = () => {
      props.setLogOut("timeout")
    }
    const [localIsLogin, setLocalIsLogin] = useState(localStorage.getItem('isLogin'))
    useEffect(()=>{
      console.log(localIsLogin,'localStorage')
      if(localIsLogin){
        setIsLogin(JSON.parse(localIsLogin))
      }
      else{
        setIsLogin(isLoginData)
      }
    },[isLoginData])
    useEffect(()=>{
      const subscribe = setInterval(()=>{
        if((Cookie.get("currentUser")) !== undefined || null ){
          const jsonData = Cookie.get('currentUser');
          let decompressedData = LZString.decompressFromBase64(jsonData);
          decompressedData = decompressedData =='\x00\x00\x00'?jsonData:decompressedData;
          const user = JSON.parse(decompressedData);
        if(localStorage.getItem("isLogin") && !window.location.pathname.includes("/welcome")){
          if(JSON.stringify(user) && localStorage.getItem('currentUser') && Cookie.get('token') && localStorage.getItem('token')){
            if(JSON.parse(localStorage.getItem("isLogin"))&&((JSON.stringify(user) !==localStorage.getItem('currentUser'))||
            (Cookie.get('token') != localStorage.getItem('token')))){
              dispatch(setLogOut("logout"))
            }
          }
            // if(JSON.parse(localStorage.getItem("isLogin"))&&((Cookie.get('currentUser') !==localStorage.getItem('currentUser'))||
            // (Cookie.get('token') !== localStorage.getItem('token')))){
            //   dispatch(setLogOut("logout"))
            //   console.log('hello')
            // }
          }
        }
      },1000)
    },[])
  // render() {
    console.log(isLogin,'isLogin')
    return (
      <>
        {
            showModal &&
            <ContentModal showModal={showModal} errors={notificationErrorList} contentModalType={"error"} bshowWarningButton={false} />
        }
        <Router>
          {/*<MessageBox title="cool" body='sample text in the body' buttonName='submit' />
<Success title='success' body='cool'></Success>*/}

          <Routes>
          <Route 
            path="/dashboardRetail" 
            element={
                <PrivateRoute>
                    <Dashboard />
                </PrivateRoute>
            } 
          />
          <Route exact path='/welcome' element={<Welcome />} />
          <Route 
              path='/Stores' 
              element={
                  <SecureRoute>
                      <Stores />
                  </SecureRoute>
              } 
          />
          <Route 
              path='/Warehouses' 
              element={
                  <SecureRoute>
                      <WareHouses />
                  </SecureRoute>
              } 
          />
          <Route 
              path='/WareHouseView' 
              element={
                  <SecureRoute>
                      <WareHouseView />
                  </SecureRoute>
              } 
          />
          <Route 
              path='/AddWareHouse' 
              element={
                  <SecureRoute>
                      <AddWareHouse />
                  </SecureRoute>
              } 
          />
          <Route 
              path='/EditWareHouse' 
              element={
                  <SecureRoute>
                      <EditWareHouse />
                  </SecureRoute>
              } 
          />
          <Route 
              path='/AddStore' 
              element={
                  <SecureRoute>
                      <AddStore />
                  </SecureRoute>
              } 
          />
          <Route 
              path='/EditStore' 
              element={
                  <SecureRoute>
                      <EditStore />
                  </SecureRoute>
              } 
          />
          <Route 
              path='/StoreView' 
              element={
                  <SecureRoute>
                      <StoreView />
                  </SecureRoute>
              } 
          />
          <Route 
              path='/AssetCategories' 
              element={
                  <SecureRoute>
                      <AssetCategoryList />
                  </SecureRoute>
              } 
          />
          <Route 
              path='/Vendors' 
              element={
                  <SecureRoute>
                      <Vendors />
                  </SecureRoute>
              } 
          />
          <Route 
              path='/VendorAdd' 
              element={
                  <SecureRoute>
                      <VendorAdd />
                  </SecureRoute>
              } 
          />
          <Route 
              path='/VendorEdit' 
              element={
                  <SecureRoute>
                      <VendorEdit />
                  </SecureRoute>
              } 
          />
          <Route 
              path='/VendorContract' 
              element={
                  <SecureRoute>
                      <VendorContract />
                  </SecureRoute>
              } 
          />
          <Route 
              path='/VendorContractMapping' 
              element={
                  <SecureRoute>
                      <VendorContractMapping />
                  </SecureRoute>
              } 
          />
          <Route 
              path='/Assets' 
              element={
                  <SecureRoute>
                      <Assets />
                  </SecureRoute>
              } 
          />
          <Route 
              path='/AddAsset' 
              element={
                  <SecureRoute>
                      <AddAsset />
                  </SecureRoute>
              } 
          />
          <Route 
              path='/PMPList' 
              element={
                  <SecureRoute>
                      <PMPList />
                  </SecureRoute>
              } 
          />
          <Route 
              path='/PMPSchedule' 
              element={
                  <SecureRoute>
                      <PMPSchedule />
                  </SecureRoute>
              } 
          />
          <Route 
              path='/PMPReschedule' 
              element={
                  <SecureRoute>
                      <PMPReschedule />
                  </SecureRoute>
              } 
          />
          <Route 
              path='/PMPScheduleCancel' 
              element={
                  <SecureRoute>
                      <PMPScheduleCancel />
                  </SecureRoute>
              } 
          />
          <Route 
              path='/PMPVendorList' 
              element={
                  <SecureRoute>
                      <PMPVendorList />
                  </SecureRoute>
              } 
          />
          <Route 
              path='/PMPVendorReschedule' 
              element={
                  <SecureRoute>
                      <PMPVendorReschedule />
                  </SecureRoute>
              } 
          />
          <Route 
              path='/PMPVendorAccept' 
              element={
                  <SecureRoute>
                      <PMPVendorAccept />
                  </SecureRoute>
              } 
          />
          <Route 
              path='/PaymentInvoiceCreation' 
              element={
                  <SecureRoute>
                      <PaymentInvoiceCreation />
                  </SecureRoute>
              } 
          />
        <Route 
            path='/PaymentInvoiceProcessSOM' 
            element={
                <SecureRoute>
                    <PaymentInvoiceProcessSOM />
                </SecureRoute>
            } 
        />
        <Route 
            path='/PaymentInvoiceProcessFinance' 
            element={
                <SecureRoute>
                    <PaymentInvoiceProcessFinance />
                </SecureRoute>
            } 
        />
        <Route 
            path='/PaymentInvoiceProcessSL' 
            element={
                <SecureRoute>
                    <PaymentInvoiceProcessSL />
                </SecureRoute>
            } 
        />
        <Route 
            path='/PaymentProcessApproveReject' 
            element={
                <SecureRoute>
                    <PaymentProcessApproveReject />
                </SecureRoute>
            } 
        />
        <Route 
            path='/PaymentProcessSOM' 
            element={
                <SecureRoute>
                    <PaymentProcessSOM />
                </SecureRoute>
            } 
        />
        <Route 
            path='/PaymentProcessSL' 
            element={
                <SecureRoute>
                    <PaymentProcessSL />
                </SecureRoute>
            } 
        />
        <Route 
            path='/PaymentRequestStore' 
            element={
                <SecureRoute>
                    <PaymentRequestStore />
                </SecureRoute>
            } 
        />
        <Route 
            path='/PaymentRequestApproveReject' 
            element={
                <SecureRoute>
                    <PaymentRequestApproveReject />
                </SecureRoute>
            } 
        />
        <Route 
            path='/BudgetCategoryMaster' 
            element={
                <SecureRoute>
                    <BudgetCategoryMaster />
                </SecureRoute>
            } 
        />
        <Route 
            path='/BudgetPlannerSM' 
            element={
                <SecureRoute>
                    <BudgetPlannerSM />
                </SecureRoute>
            } 
        />
        <Route 
            path='/BudgetPlannerSOM' 
            element={
                <SecureRoute>
                    <BudgetPlannerSOM />
                </SecureRoute>
            } 
        />
        <Route 
            path='/BudgetPlannerApprovalZOMC' 
            element={
                <SecureRoute>
                    <BudgetPlannerApprovalZOMC />
                </SecureRoute>
            } 
        />
        <Route 
            path='/BudgetPlannerApprovalProcessZOMC' 
            element={
                <SecureRoute>
                    <BudgetPlannerApprovalProcessZOMC />
                </SecureRoute>
            } 
        />
        <Route 
            path='/BudgetPlannerApprovalFinance' 
            element={
                <SecureRoute>
                    <BudgetPlannerApprovalFinance />
                </SecureRoute>
            } 
        />
        <Route 
            path='/BudgetPlannerApprovalProcessFinance' 
            element={
                <SecureRoute>
                    <BudgetPlannerApprovalProcessFinance />
                </SecureRoute>
            } 
        />
        <Route 
            path='/notAllowed' 
            element={
                <SecureRoute>
                    <FedIDUrl />
                </SecureRoute>
            } 
        />
        <Route 
            path='/pageNotAllowed' 
            element={
                <SecureRoute>
                    <PageNotAllowed />
                </SecureRoute>
            } 
        />
        <Route 
            path='/welcome' 
            element={
                <SecureRoute>
                    <Welcome />
                </SecureRoute>
            } 
        />
        <Route 
            path='/WarehouseLeader' 
            element={
                <SecureRoute>
                    <WarehouseLeader />
                </SecureRoute>
            } 
        />
        <Route 
            path='/AddDecathlonUser' 
            element={
                <SecureRoute>
                    <AddDecathlonUser />
                </SecureRoute>
            } 
        />
        <Route 
            path='/ChangeUsersStore' 
            element={
                <SecureRoute>
                    <ChangeUsersStore />
                </SecureRoute>
            } 
        />
        <Route 
            path='/RemoveUser' 
            element={
                <SecureRoute>
                    <RemoveUser />
                </SecureRoute>
            } 
        />
        <Route 
            path='/MaintenenceStoreDashBoard' 
            element={
                <SecureRoute>
                    <MaintenenceStoreDashBoard />
                </SecureRoute>
            } 
        />
        <Route 
            path='/MaintenenceWareHouseDashBoard' 
            element={
                <SecureRoute>
                    <MaintenenceWareHouseDashBoard />
                </SecureRoute>
            } 
        />
        <Route 
            path='/MaintenanceDashboard' 
            element={
                <SecureRoute>
                    <MaintenanceDashboard />
                </SecureRoute>
            } 
        />
        <Route 
            path='/MaintenanceDashboardReport' 
            element={
                <SecureRoute>
                    <MaintenanceDashboardReport />
                </SecureRoute>
            } 
        />
        <Route 
            path='/DeliveryEfficiency' 
            element={
                <SecureRoute>
                    <DeliveryEfficiency />
                </SecureRoute>
            } 
        />
        <Route 
            path='/WorkOrder' 
            element={
                <SecureRoute>
                    <WorkOrder />
                </SecureRoute>
            } 
        />
        <Route 
            path='/WorkOrderVendor' 
            element={
                <SecureRoute>
                    <WorkOrderVendor />
                </SecureRoute>
            } 
        />
        <Route 
            path='/WorkOrderStore' 
            element={
                <SecureRoute>
                    <WorkOrderStore />
                </SecureRoute>
            } 
        />
        <Route 
            path='/WOReSchedule' 
            element={
                <SecureRoute>
                    <WOReSchedule />
                </SecureRoute>
            } 
        />
        <Route 
            path='/QuotationStore' 
            element={
                <SecureRoute>
                    <QuotationStore />
                </SecureRoute>
            } 
        />
        <Route 
            path='/QuotationVendor' 
            element={
                <SecureRoute>
                    <QuotationVendor />
                </SecureRoute>
            } 
        />
        <Route 
            path='/AddQuotation' 
            element={
                <SecureRoute>
                    <AddQuotation />
                </SecureRoute>
            } 
        />
        <Route 
            path='/ViewQuotation' 
            element={
                <SecureRoute>
                    <ViewQuotation />
                </SecureRoute>
            } 
        />
        <Route 
            path='/EditQuotation' 
            element={
                <SecureRoute>
                    <EditQuotation />
                </SecureRoute>
            } 
        />
        <Route 
            path='/tpv' 
            element={
                <SecureRoute>
                    <TpvList />
                </SecureRoute>
            } 
        />








            {/* <Route
              exact
              path='/'
              //component={<FedIDUrl />}
              component={() => {
                window.location.href = process.env.REACT_APP_LOAD_URL;

                return null;
              }}
            /> */}
     
           <Route 
            path="/tpvAdd" 
            element={
                <PrivateRoute>
                    <TpvAdd />
                </PrivateRoute>
            } 
            />
        <Route 
            path="/previewTpvReport" 
            element={
                <PrivateRoute>
                    <PreviewTpvReport />
                </PrivateRoute>
            } 
        />
        <Route 
            path="/Auditor" 
            element={
                <PrivateRoute>
                    <Auditor />
                </PrivateRoute>
            } 
        />
        <Route 
            path="/AuditorAdd" 
            element={
                <PrivateRoute>
                    <AuditorAdd />
                </PrivateRoute>
            } 
        />
        <Route 
            path="/AuditorEdit" 
            element={
                <PrivateRoute>
                    <AuditorEdit />
                </PrivateRoute>
            } 
        />
        <Route 
            path="/AuditorContract" 
            element={
                <PrivateRoute>
                    <AuditorContract />
                </PrivateRoute>
            } 
        />
        <Route 
            path="/AuditorContractMapping" 
            element={
                <PrivateRoute>
                    <AuditorContractMapping />
                </PrivateRoute>
            } 
        />
        <Route 
            path="/storeDashboardRetail" 
            element={
                <PrivateRoute>
                    <StoreDashboardRetail />
                </PrivateRoute>
            } 
        />
        <Route 
            path="/WasteManagementDashboard" 
            element={
                <PrivateRoute>
                    <WasteManagementDashboard />
                </PrivateRoute>
            } 
        />
        <Route 
            path="/storeDashboardWareHouse" 
            element={
                <PrivateRoute>
                    <StoreDashboardWareHouse />
                </PrivateRoute>
            } 
        />
        <Route 
            path="/dashboardWareHouse" 
            element={
                <PrivateRoute>
                    <WareHouseDashBoard />
                </PrivateRoute>
            } 
        />
        <Route 
            path="/cityleader" 
            element={
                <PrivateRoute>
                    <Cityleader />
                </PrivateRoute>
            } 
        />
        <Route 
            path="/incidents" 
            element={
                <PrivateRoute>
                    <Incidents />
                </PrivateRoute>
            } 
        />
        <Route 
            path="/evacuations" 
            element={
                <PrivateRoute>
                    <Evacuations />
                </PrivateRoute>
            } 
        />
        <Route 
            path="/nonconformities" 
            element={
                <PrivateRoute>
                    <Nonconformities />
                </PrivateRoute>
            } 
        />
        <Route 
            path="/projectTracker" 
            element={
                <PrivateRoute>
                    <ProjectTracker />
                </PrivateRoute>
            } 
        />
        <Route 
            path="/projectTracker/project" 
            element={
                <PrivateRoute>
                    <Project />
                </PrivateRoute>
            } 
        />
        <Route 
            path="/projectTracker/purchaseorder" 
            element={
                <PrivateRoute>
                    <PurchaseOrder />
                </PrivateRoute>
            } 
        />
        <Route 
            path="/safetyRegister" 
            element={
                <PrivateRoute>
                    <SafetyRegister />
                </PrivateRoute>
            } 
        />
        <Route 
            path="/pdfExport" 
            element={
                <PrivateRoute>
                    <PdfExport />
                </PrivateRoute>
            } 
        />
        <Route 
            path="/pdfExportStore" 
            element={
                <PrivateRoute>
                    <PdfExportStore />
                </PrivateRoute>
            } 
        />
        <Route 
            path="/pdfWarehouse" 
            element={
                <PrivateRoute>
                    <PdfStoreWarehouse />
                </PrivateRoute>
            } 
        />
        <Route 
            path="/pdfwarehouseGlobal" 
            element={
                <PrivateRoute>
                    <PdfExportWarehouse />
                </PrivateRoute>
            } 
        />
        <Route 
            path="/pdfExportCityLeader" 
            element={
                <PrivateRoute>
                    <PdfExportCityLeader />
                </PrivateRoute>
            } 
        />
        <Route 
            path="/adduser" 
            element={
                <PrivateRoute>
                    <AddUser />
                </PrivateRoute>
            } 
        />
        <Route 
            path="/editIncidentEmailConfig" 
            element={
                <PrivateRoute>
                    <EditIncidentEmailConfig />
                </PrivateRoute>
            } 
        />
        <Route 
            path="/editChecklist" 
            element={
                <PrivateRoute>
                    <EditChecklist />
                </PrivateRoute>
            } 
        />
        <Route 
            path="/manageuserstores" 
            element={
                <PrivateRoute>
                    <ManageUserStores />
                </PrivateRoute>
            } 
        />
        <Route 
            path="/fedIdExtract" 
            element={
                <PrivateRoute>
                    <FedIdExtract />
                </PrivateRoute>
            } 
        />
        <Route 
            path="/training" 
            element={
                <PrivateRoute>
                    <Training />
                </PrivateRoute>
            } 
        />
        <Route 
            path="/diagnosis" 
            element={
                <PrivateRoute>
                    <Audits />
                </PrivateRoute>
            } 
        />
        <Route 
            path="/gatePass" 
            element={
                <PrivateRoute>
                    <GatePass />
                </PrivateRoute>
            } 
        />
        <Route 
            path="/handovers" 
            element={
                <PrivateRoute>
                    <Handovers />
                </PrivateRoute>
            } 
        />
        <Route 
            path="/handovers/viewImages" 
            element={
                <PrivateRoute>
                    <ViewImages />
                </PrivateRoute>
            } 
        />
        <Route 
            path="/diagnosis/viewImages" 
            element={
                <PrivateRoute>
                    <ViewImages />
                </PrivateRoute>
            } 
        />

         
            <Route path='*' element={<NoMatch />}>
            </Route>
            <Route exact path='/' element={<Login />} />
          </Routes>
        </Router>
        <SessionTimeout isAuthenticated={isLogin} logOut={handleClick} />
      </>
    );
}
const mapDispatchToProps = dispatch =>({
  ...bindActionCreators({setLogOut},dispatch)
})
const mapStateToProps = state =>({
})
export default connect(mapStateToProps, mapDispatchToProps) (App);
